<template>

  <svg
    t="1639130833808"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3985"
    width="64"
    height="64"
  ><path d="M341.33333333 579.33333333C426.66933333 463.33333333 511.99733333 405.33333333 597.33333333 405.33333333c85.336 0 170.664 58 256 174C767.99733333 676.66933333 682.66933333 725.33333333 597.33333333 725.33333333c-85.336 0-170.664-48.664-256-146z m96-5.6C490.66933333 632.13333333 543.99733333 661.33333333 597.33333333 661.33333333s106.664-29.2 160-87.6C703.99733333 504.13333333 650.66933333 469.33333333 597.33333333 469.33333333s-106.664 34.8-160 104.4zM597.33333333 629.33333333a64 64 0 1 1 0-128 64 64 0 0 1 0 128zM213.33333333 213.33333333V85.33333333h64v128h640v64H277.33333333v640h-64V277.33333333H85.33333333v-64h128z" p-id="3986" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconLineShow',
} as DefineComponent
</script>